<!-- VerticalSpacer.vue -->
<script lang="ts" setup>

</script>

<template>
    <span style="border-left: 2px solid grey;"></span>
</template>